import * as Styled from './SplitButton.styles';
import { Button, ClickAwayListener, Divider, Grow, MenuItem, MenuList, Paper, Popper, } from '@mui/material';
import React, { useRef, useState } from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
const addKey = (option, i) => ({
    ...option,
    key: i,
});
/**
 * Button with dropdown to change action
 */
export const SplitButton = ({ options, oneClickMenu, includeSelectedInMenu, selectedIcon, variant, color, className, popupZIndex, initialSelectedIndex, disabled, }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(initialSelectedIndex ? initialSelectedIndex : 0);
    const selected = options[selectedIndex];
    const handleClick = (index) => {
        const selectedMenuItem = options[index];
        if (oneClickMenu) {
            selectedMenuItem.onClick && selectedMenuItem.onClick();
        }
        else {
            selected.onClick && selected.onClick();
        }
        setOpen(false);
    };
    const handleMenuItemClick = (index) => () => {
        if (oneClickMenu)
            handleClick(index);
        else
            setSelectedIndex(index);
        setOpen(false);
    };
    const toggleDropdown = () => {
        setOpen(!open);
    };
    const menuOptions = includeSelectedInMenu
        ? options.map(addKey)
        : options
            .map(addKey)
            .filter((option, index) => index !== selectedIndex);
    const handleClose = (e) => {
        if (anchorRef.current &&
            anchorRef.current.contains(e.target)) {
            return;
        }
        setOpen(false);
    };
    return (React.createElement(Styled.Wrapper, { className: className },
        React.createElement(Styled.StyledButtonGroup, { variant: variant, ref: anchorRef },
            React.createElement(Button, { onClick: () => handleClick(selectedIndex), color: color, disabled: disabled || selected.disabled, "data-test-id": "action-button", "data-cy": selected.cy },
                selected.icon && selectedIcon && (React.createElement(Styled.SelectedIcon, null, selected.icon)),
                selected.title),
            React.createElement(Button, { onClick: toggleDropdown, size: "small", color: color, disabled: disabled, "data-test-id": "dropdown" },
                React.createElement(ExpandMore, null))),
        React.createElement(Popper, { open: open, anchorEl: anchorRef.current, placement: "bottom-end", transition: true, style: { zIndex: popupZIndex ? popupZIndex : 'auto' } }, ({ TransitionProps }) => (React.createElement(Grow, { ...TransitionProps },
            React.createElement(Paper, { square: true },
                React.createElement(ClickAwayListener, { onClickAway: handleClose },
                    React.createElement(MenuList, null, menuOptions.map(({ title, icon, key, disabled: itemDisabled, divider, }, i) => (React.createElement("div", { key: i },
                        divider && React.createElement(Divider, null),
                        React.createElement(MenuItem, { key: `menu-item-${title}`, selected: includeSelectedInMenu &&
                                i === selectedIndex, disabled: itemDisabled, onClick: handleMenuItemClick(key) },
                            icon && (React.createElement(Styled.Icon, null, icon)),
                            title))))))))))));
};
SplitButton.defaultProps = {
    oneClickMenu: false,
    includeSelectedInMenu: true,
    selectedIcon: false,
    variant: 'contained',
    color: 'primary',
};
export default SplitButton;
